import GreenTopbarModernThumbnailPath from '../../../assets/template-thumbnails/topbar-center/green-modern-topbar-centered-template-thumbnail.png';

const GreenTopbarModernTemplate = {
    id: 'green-modern-topbar-template',
    name: 'Green Modern',
    category: 'Topbar Modern',
    settings: {
      layoutId: 'topbar-centered',
      designId: 'custom',
      style: 'tech',
      background: 'blank',
      barStyleId: 'bars',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#1DB954",
        secondary: "#191414",
        tertiary: "#1ED760",
        quaternary: "#535353",
        accent1: "#CDF564",
        accent2: "#509BF5",
        accent3: "#4687FB",
        accent4: "#2D46B9",
        accent5: "#AF2896",
        accent6: "#F037A5",
        accent7: "#B3B3B3",
        accent8: "#FFFFFF",
        text: "#191414",
        textSecondary: "#535353",
        background: "#FFFFFF",
        sidebarBackground: "rgba(29, 185, 84, 1)",
        border: "rgba(29, 185, 84, 1)",
        sidebarPrimary: "rgba(255, 255, 255, 1)",
        sidebarText: "rgba(255, 255, 255, 1)"
      },
      typography: {
        cvTitle: { fontSize: 24, lineHeight: 1.4, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 12, lineHeight: 1.2, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 10, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: GreenTopbarModernThumbnailPath
  };

export default GreenTopbarModernTemplate; 